import { useDispatch } from "react-redux";
import { setSnackbar } from "reduxStore/state";
import {
  createPrinciple,
  updatePrinciple,
} from "reduxStore/actions/principleActions";
import * as Yup from "yup";

export const usePrinciplesForm = ({ editMode, setOpen, currentPrinciple }) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    principleNumber: Yup.number().required("Principle Number is required"),
    description: Yup.string().required("Description is required"),
  });

  const initialValues = {
    name: currentPrinciple ? currentPrinciple.name : "",
    principleNumber: currentPrinciple ? currentPrinciple.principleNumber : "",
    description: currentPrinciple ? currentPrinciple.description : "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      let response;
      if (editMode) {
        response = await dispatch(
          updatePrinciple(currentPrinciple._id, values)
        );
      } else {
        response = await dispatch(createPrinciple(values));
      }

      if (response) {
        dispatch(
          setSnackbar({
            open: true,
            message: editMode
              ? "Principle updated successfully"
              : "Principle created successfully",
            severity: "success",
          })
        );
        setOpen(false);
      } else {
        dispatch(
          setSnackbar({
            open: true,
            message: "An error occurred",
            severity: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        setSnackbar({
          open: true,
          message: "An error occurred",
          severity: "error",
        })
      );
    } finally {
      setOpen(false);
      setSubmitting(false);
    }
  };

  return {
    validationSchema,
    initialValues,
    handleSubmit,
  };
};
